module.exports = __webpack_public_path__ + "img/orbit-planet-claim.7375d500.png";